module.exports = __webpack_public_path__ + "img/MEDIA002.eb37bd82.jpg";